export default "__VITE_ASSET__DLlr23IA__"